import React, { useMemo } from "react";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { GlobalProgramStatusType } from "@domain/program/program-status/program-status";

export type ProgramStatusLabelProps = {
	type: GlobalProgramStatusType;
};

export const ProgramStatusLabel: React.FC<ProgramStatusLabelProps> = ({ type }) => {
	const { format } = useI18n();
	const label = useMemo(() => {
		switch (type) {
			case GlobalProgramStatusType.NoProgram:
				return format("global.programStatus.labels.draft");
			case GlobalProgramStatusType.OngoingProgram:
				return format("global.programStatus.ongoing");
			case GlobalProgramStatusType.EndedLastProgramDetailsMode:
			case GlobalProgramStatusType.EndedLastProgram:
				return format("global.programStatus.labels.ended");
			case GlobalProgramStatusType.ScheduledProgram:
				return format("global.programStatus.labels.scheduled");
		}
	}, [format, type]);

	return <Container className="p-size-s">{label}</Container>;
};

const Container = styled.div`
	color: ${colors.black};
	background-color: ${colors.primaryBackground};
	border-radius: 8px;
	padding: 6px 12px;
`;
